export const regex = {
  email: /^[\w-+_]+(\.?[\w-+_]+)+@(\w[-_\w]*\.){1,5}[A-Za-z]{2,10}$/,
  url: /(http|https):\/\/.+\..+/,
  digits: /^\d*$/,
  phone: /^[\d+][\d \-/]*$/
};
